var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 815,
    height: 320,
    viewBox: "0 0 815 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.028 338.507C214.91 268.423 289.122 126.963 426.907 121.793C599.14 115.33 629.114 -64.4679 620.924 -144.959C614.372 -209.352 668.286 -257.15 696.063 -273",
    stroke: "#E5E7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.803 363.66C225.686 293.577 299.897 152.116 437.683 146.946C609.915 140.483 639.889 -39.3144 631.699 -119.805C625.147 -184.198 679.062 -231.997 706.838 -247.847",
    stroke: "#E5E7FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.579 388.814C236.461 318.73 310.672 177.27 448.458 172.1C620.69 165.637 650.665 -14.1609 642.475 -94.652C635.922 -159.045 689.837 -206.843 717.613 -222.693",
    stroke: "#E5E7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.354 413.968C247.236 343.884 321.447 202.423 459.233 197.253C631.465 190.79 661.44 10.9926 653.25 -69.4985C646.698 -133.891 700.612 -181.689 728.388 -197.539",
    stroke: "#E5E7FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.664 438.386C257.619 368.417 331.959 227.161 469.68 221.888C641.831 215.296 672.003 35.8107 663.912 -44.5231C657.44 -108.79 711.383 -156.543 739.164 -172.386",
    stroke: "#E5E7FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.439 463.539C268.322 393.456 342.533 251.995 480.319 246.825C652.551 240.362 682.525 60.5646 674.335 -19.9265C667.783 -84.3194 721.698 -132.118 749.474 -147.968",
    stroke: "#E5E7FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259.215 488.693C279.097 418.609 353.308 277.149 491.094 271.979C663.326 265.516 693.301 85.7182 685.111 5.22706C678.558 -59.1658 732.473 -106.964 760.249 -122.814",
    stroke: "#E5E7FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M269.99 513.847C289.872 443.763 364.083 302.302 501.869 297.132C674.101 290.669 704.076 110.872 695.886 30.3806C689.334 -34.0123 743.248 -81.8105 771.024 -97.6604",
    stroke: "#E5E7FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.765 539C300.647 468.916 374.859 327.456 512.644 322.286C684.877 315.823 714.851 136.025 706.661 55.5341C700.109 -8.85881 754.023 -56.657 781.8 -72.5069",
    stroke: "#E5E7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.d7d32a5d5590598b79c870a5952bbd08.svg";
export { ForwardRef as ReactComponent };